import { CircularProgress } from "@mui/material";
import React from "react";

export const CircularLoader = () => {
  function GradientCircularProgress() {
    return (
      <React.Fragment>
        <svg width={0} height={0}>
          <defs>
            <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#15741a" />
              <stop offset="100%" stopColor="#ffbf00" />
            </linearGradient>
          </defs>
        </svg>
        <CircularProgress
          size={20}
          sx={{ "svg circle": { stroke: "url(#my_gradient)" } }}
        />
      </React.Fragment>
    );
  }
  return <GradientCircularProgress />;
};
